/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { GraphQLDocuments } from "@graphql/graphQLDocuments";
import { GetApplicantsQuery, GetApplicantsQueryVariables } from "@models/graphql";
import { QueryHookOptions, useQuery } from "@apollo/react-hooks";

export const useGetApplicants = (options?: QueryHookOptions<GetApplicantsQuery, GetApplicantsQueryVariables>) => {
    const { data, error, loading } = useQuery<GetApplicantsQuery, GetApplicantsQueryVariables>(GraphQLDocuments.getApplicants, options);

    return {
        applicants: data && data.cardsApplicants ? data.cardsApplicants : [],
        applicantsLoading: loading,
        applicantsError: error
    };
};
